import { createStore } from "vuex";
import AuthModule from "./modules/Auth";
import Orders from "./modules/Orders";
import Sites from "./modules/Sites";
import Finances from "./modules/Finances";
import shipTypes from "./modules/shipTypes";
import Invoices from "./modules/Invoices";
import Parts from "./modules/Parts";
import Category from "./modules/Category";
import settingServices from "@/services/Settings";
import Alert from "./modules/Alert";

const store = createStore({
  modules: {
    //namespaced
    AuthModule,
    Orders,
    Sites,
    Parts,
    Finances,
    shipTypes,
    Invoices,
    Category,
    Alert,
  },
  state() {
    //data
    return {
      loading: false,
      openMenu: false,
      isMobile: false,
      isTablet: false,
      isLaptop: false,
      isDesktop: false,
      isOpenMobileSideBar: false,
      isShowDesktopHome: false,
      mobileNavSelectedOptionText: "",
      websiteSettings: [],
      version: "1.0.16",
    };
  },
  mutations: {
    setLoading(state, mode) {
      state.loading = mode;
    },
    setToastColor(state, status) {
      switch (status) {
        case "success":
          state.toastColor = "green darken-1";
          break;
        case "error":
          state.toastColor = "red darken-1";
          break;
        case "warning":
          state.toastColor = "yellow darken-1";
          break;
        case "info":
          state.toastColor = "blue darken-1";
          break;
        case "":
          state.toastColor = "";
          break;
      }
    },
    setIsShowToast(state, mode) {
      state.isShowToast = mode;
    },
    setToastMessage(state, message) {
      state.toastMessage = message;
    },
    setMobileNavText(state, selectedText) {
      state.mobileNavSelectedOptionText = selectedText;
    },
    toggleMenu(state) {
      state.openMenu = !state.openMenu;
    },
    setMenuToOpen(state) {
      state.openMenu = true;
    },
    setMenuToClose(state) {
      state.openMenu = false;
    },
    setIsMobile(state, value) {
      state.isMobile = value;
    },
    setIsTablet(state, value) {
      state.isTablet = value;
    },
    setIsLaptop(state, value) {
      state.isLaptop = value;
    },
    setIsDesktop(state, value) {
      state.isDesktop = value;
    },
    setIsOpenMobileSideBar(state, value) {
      state.isOpenMobileSideBar = value;
    },
    setIsShowDesktopHome(state, value) {
      state.isShowDesktopHome = value;
    },
  }, //methods for update the state, only here! not in actions!!!
  actions: {
    async getWebsiteSettings({ state }) {
      try {
        const websiteSettingsRes = await settingServices.getWebsiteSettings();
        state.websiteSettings = websiteSettingsRes.data;
      } catch (err) {
        console.log(err);
      }
    },
    startLoading(context) {
      context.commit("setLoading", true);
    },
    stopLoading(context) {
      context.commit("setLoading", false);
    },
    ShowToast(context, { message, status }) {
      context.commit("setToastColor", status);
      context.commit("setIsShowToast", true);
      context.commit("setToastMessage", message);
      setTimeout(() => {
        context.commit("setToastColor", "");
        context.commit("setIsShowToast", false);
        context.commit("setToastMessage", "");
      }, 5000);
    },
  },
  getters: {
    getWhatsappNum: (state) =>
      state.websiteSettings.find((setting) => setting.id == "whatsapp")
        ?.value,
    isShippingEnabled: (state) => {
      const val = state.websiteSettings.find(
        (setting) => setting.id === "shippingRivhitItemId"
      )?.value;
      return !!val && Number.isFinite(Number(val)) && Number(val) > 0;
    },
    isOpenMenu(state) {
      return state.openMenu;
    },
    getMobileNavText(state) {
      return state.mobileNavSelectedOptionText;
    },
    isMobile(state) {
      return state.isMobile;
    },
    isTablet(state) {
      return state.isTablet;
    },
    isLaptop(state) {
      return state.isLaptop;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    isLoading(state) {
      return state.loading;
    },
    getAppVersion(state) {
      return state.version;
    },
    isOpenMobileSideBar(state) {
      return state.isOpenMobileSideBar && (state.isMobile || state.isTablet);
    },
    isShowDesktopHome(state) {
      return state.isShowDesktopHome;
    },
    isShowToast(state) {
      return state.isShowToast;
    },
    toastColor(state) {
      return state.toastColor;
    },
    toastMessage(state) {
      return state.toastMessage;
    },
    isPwaInstalled() {
      return (
        window.matchMedia("(display-mode: standalone)").matches ||
        window.navigator.standalone
      );
    },
  },
});

export default store;
